export default "__VITE_ASSET__zAgeQoTI__"